import { render } from "./MenuEdicion.vue?vue&type=template&id=a3d12c9e"
import script from "./MenuEdicion.vue?vue&type=script&lang=js"
export * from "./MenuEdicion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__